import { render, staticRenderFns } from "./_ChangeAdminPassword.vue?vue&type=template&id=1fb68f50"
import script from "./_ChangeAdminPassword.vue?vue&type=script&lang=js"
export * from "./_ChangeAdminPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports